import { webStorage } from 'sidecar-utilities'

const proxyEnv =
  { dev: 'dev-', qa: 'qa-', prod: 'prod-' }[process.env.APP_ENV] || 'dev-'

// only use the contentful staging environment for localhost and DEV
// PROD and QA shall use the contentful master environment
const contentfulEnvironment =
  process.env.APP_ENV === 'qa' || process.env.APP_ENV === 'prod'
    ? 'master'
    : 'staging'

export const contentfulEndpoint = `https://${proxyEnv}proxy.sidecarhealth.com/contentful/content/v1/spaces/${process.env.REACT_APP_SPACE_ID}/environments/${contentfulEnvironment}`

/**
 * Headers for Contentful requests routed through the proxy (API Gateway).
 *
 * - `x-api-key` identifies the calling app to the gateway (existing behavior).
 * - `token` carries the member's auth token so the proxy's Lambda Authorizer can
 *   validate the caller. Required once the prod API Gateway enforces
 *   authorization (MX-4658). Read at call time so the current token is used.
 */
export const getContentfulProxyHeaders = () => ({
  'x-api-key': process.env.PROXY_X_API_KEY,
  token: webStorage.getItem('token') || '',
})
